<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model :model="model" :rules="validatorRules" @keyup.enter.native="submitForm" ref="form" slot="detail">
        <a-row>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="厂家名称" prop="manuName">
              <a-input placeholder="请输入厂家名称" v-model="model.manuName"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系人" prop="contactPerson">
              <a-input placeholder="请输入联系人" v-model="model.contactPerson"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系电话" prop="contactPhone">
              <a-input placeholder="请输入联系电话" v-model="model.contactPhone"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="电子邮件" prop="contactEmail">
              <a-input placeholder="请输入电子邮件" v-model="model.contactEmail"></a-input>
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="行业分类" prop="trade">
              <a-input placeholder="请输入行业分类" v-model="model.trade"></a-input>
            </a-form-model-item>
          </a-col>-->
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="经营范围" prop="businessScope">
              <a-textarea placeholder="请输入经营范围" v-model="model.businessScope"></a-textarea>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="地址" prop="addr">
              <a-textarea placeholder="请输入地址" v-model="model.addr"></a-textarea>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="备注" prop="remark">
              <a-textarea placeholder="请输入备注" v-model="model.remark"></a-textarea>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'CommonManufacturerForm',
    components: {
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model: {
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 3 },
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
        confirmLoading: false,
        validatorRules: {
          manuName: [
            { required: true, message: '请输入厂家名称!' },
          ]
        },
        url: {
          add: "/device/commonManufacturer/add",
          edit: "/device/commonManufacturer/edit",
          queryById: "/device/commonManufacturer/queryById"
        }
      }
    },
    computed: {
      formDisabled () {
        return this.disabled
      },
    },
    created () {
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      add () {
        this.edit(this.modelDefault);
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(async valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if (!this.model.id) {
              httpurl += this.url.add;
              method = 'post';
            } else {
              httpurl += this.url.edit;
              method = 'put';
            }
            // httpAction(httpurl, this.model, method).then((res) => {
            //   if (res.success) {
            //     that.$message.success(res.message);
            //     that.$emit('ok');
            //   } else {
            //     that.$message.warning(res.message);
            //   }
            // }).finally(() => {
            //   that.confirmLoading = false;
            // })
            const { success, message, result } = await httpAction(httpurl, this.model, method)
            if (success) {
              that.$message.success('添加成功')
              that.$emit('ok', result)
            } else {
              that.$message.warning(message)
            }
            that.confirmLoading = false

          }

        })
      },
    }
  }
</script>